import { Show } from 'solid-js';
import { Input } from './Input';

export const NumberRangePicker = (props: {
  label: string;
  value: { start: string | number; end: string | number };
  min?: number;
  max?: number;
  required?: boolean;
  disabled?: boolean;
  hint?: string;
  error?: string;
  onChange: (value: { start: string | number; end: string | number }) => void;
}) => {
  const min = () => props.min ?? Math.min(0, Number(props.value.start) || 0);
  const max = () => props.max ?? Math.max(100, Number(props.value.end) || 0);
  const start = () => (props.value.start === '' ? min() : Number(props.value.start));
  const end = () => (props.value.end === '' ? max() : Number(props.value.end));
  const percent = (value: number) =>
    max() === min() ? 0 : Math.max(0, Math.min(100, ((value - min()) / (max() - min())) * 100));
  return (
    <fieldset disabled={props.disabled} class="space-y-3">
      <legend class="mb-2 font-medium text-neutral-700 dark:text-neutral-300">
        {props.label}
        {props.required ? ' *' : ''}
      </legend>
      <div class="relative mx-2 flex h-10 items-center">
        <div class="h-2 w-full rounded-full bg-neutral-200 dark:bg-neutral-700" />
        <div
          class="absolute h-2 rounded-full bg-brand-600"
          style={`left: ${percent(start())}%; right: ${100 - percent(end())}%`}
        />
        <input
          type="range"
          aria-label={`${props.label} minimum`}
          min={min()}
          max={max()}
          step="any"
          value={start()}
          class="poll-range absolute w-full"
          onInput={(e) =>
            props.onChange({ start: Math.min(Number(e.currentTarget.value), end()), end: end() })
          }
        />
        <input
          type="range"
          aria-label={`${props.label} maximum`}
          min={min()}
          max={max()}
          step="any"
          value={end()}
          class="poll-range absolute w-full"
          onInput={(e) =>
            props.onChange({
              start: start(),
              end: Math.max(Number(e.currentTarget.value), start()),
            })
          }
        />
      </div>
      <div class="grid grid-cols-2 gap-2">
        <Input
          label="Start"
          type="number"
          min={props.min}
          max={props.max}
          value={props.value.start}
          onInput={(e) =>
            props.onChange({
              ...props.value,
              start: e.currentTarget.value === '' ? '' : Number(e.currentTarget.value),
            })
          }
        />
        <Input
          label="End"
          type="number"
          min={props.min}
          max={props.max}
          value={props.value.end}
          onInput={(e) =>
            props.onChange({
              ...props.value,
              end: e.currentTarget.value === '' ? '' : Number(e.currentTarget.value),
            })
          }
        />
      </div>
      <Show when={props.error || props.hint}>
        <p class={props.error ? 'text-xs text-red-600' : 'text-xs text-neutral-500'}>
          {props.error || props.hint}
        </p>
      </Show>
    </fieldset>
  );
};
